import { InjectionToken, inject, type Signal } from '@angular/core';
import type { GetBuildingDocumentStorageUsageResponse } from '@quipex/shared/contracts';
import type { BuildingDetails } from './models';

export interface BuildingDocumentStorageState {
    readonly usage: Signal<GetBuildingDocumentStorageUsageResponse | undefined>;
    readonly isLoading: Signal<boolean>;
    readonly error: Signal<unknown>;
}

export interface BuildingContext {
    readonly buildingDetails: Signal<BuildingDetails | undefined>;
    readonly buildingDetailsError?: Signal<unknown>;
    readonly isLoading: Signal<boolean>;
    readonly documentStorage: BuildingDocumentStorageState;
    reloadBuildingDetails(): void;
    reloadDocumentStorageUsage(): void;
}

export const BUILDING_CONTEXT = new InjectionToken<BuildingContext>(
    'BuildingContext'
);

export function injectBuildingContext(): BuildingContext {
    return inject(BUILDING_CONTEXT);
}
